import { Setlist } from '@/graphql';
import { format } from 'date-fns';

import { GenerateSetlistProps } from '../GenerateSetlist';

type LimitedSetlist = Pick<
	Setlist,
	| 'id'
	| 'serviceId'
	| 'startAt'
	| 'teamSongIds'
	| 'generateSettings'
	| 'teamSongOverrides'
>;

export default (setlist: LimitedSetlist): GenerateSetlistProps['config'] => ({
	selectedSongIds: setlist.teamSongIds,
	songOverrides: setlist.teamSongOverrides.filter(
		(override) => override.defaultKey,
	),
	setlistId: setlist.id,
	generateSettings: {
		serviceId: setlist.serviceId,
		totalSongPositions:
			setlist.generateSettings?.totalSongPositions ||
			setlist.teamSongIds.length,
		postSermonSongPosition:
			setlist.generateSettings?.postSermonSongPosition,
		searchTerm: setlist.generateSettings?.searchTerm || '',
		startDate: setlist.startAt,
		startTime: format(new Date(setlist.startAt), 'HH:mm') || '',
		bibleReference:
			setlist.generateSettings?.bibleReference ||
			setlist.generateSettings?.bibleVerseReference ||
			'',
	},
});
